'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RadioComponent = require('./RadioComponent');

var _RadioComponent2 = _interopRequireDefault(_RadioComponent);

var _PropTypes = require('../../validators/common/PropTypes');

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a group of radio inputs.
 * @extends {Component}
 */
var RadioGroupComponent = function (_React$Component) {
  _inherits(RadioGroupComponent, _React$Component);

  function RadioGroupComponent() {
    _classCallCheck(this, RadioGroupComponent);

    return _possibleConstructorReturn(this, (RadioGroupComponent.__proto__ || Object.getPrototypeOf(RadioGroupComponent)).apply(this, arguments));
  }

  _createClass(RadioGroupComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var tugoMQ = this.props.tugoMq ? 'tugo-mq' : '';
      var _props = this.props,
          applicants = _props.applicants,
          htmlId = _props.htmlId,
          options = _props.options,
          field = _props.field,
          isInlineGroup = _props.isInlineGroup,
          onChangeHook = _props.onChangeHook,
          disabled = _props.disabled;


      if (Array.isArray(applicants) && applicants.length > 0) {
        return _react2.default.createElement(
          'div',
          { className: tugoMQ + ' ingle-form-radio-group' },
          applicants.map(function (applicant, index) {
            var applicantName = (applicant.first_name.value || '') + ' ' + (applicant.last_name.value || '');
            var applicantField = field[index];

            return _react2.default.createElement(
              'div',
              { key: index, className: 'mq-applicant-row' },
              _react2.default.createElement(
                'div',
                { className: 'mq-applicant-name' },
                applicantName
              ),
              _react2.default.createElement(
                'span',
                { id: htmlId, className: tugoMQ + ' ingle-form-radio-group' },
                options && options.map(function (element, optIndex) {
                  return _react2.default.createElement(_RadioComponent2.default, {
                    key: optIndex,
                    field: applicantField,
                    isInline: isInlineGroup,
                    htmlValue: element.value,
                    htmlText: element.text,
                    onChangeHook: onChangeHook,
                    disabled: disabled,
                    tugoMq: _this2.props.tugoMq
                  });
                })
              )
            );
          })
        );
      }

      return _react2.default.createElement(
        'span',
        { id: htmlId, className: tugoMQ + ' ingle-form-radio-group' },
        options.map(function (element, index) {
          return _react2.default.createElement(_RadioComponent2.default, {
            key: index,
            field: field,
            isInline: isInlineGroup,
            htmlValue: element.value,
            htmlText: element.text,
            onChangeHook: onChangeHook,
            disabled: disabled
          });
        })
      );
    }
  }]);

  return RadioGroupComponent;
}(_react2.default.Component);

RadioGroupComponent.propTypes = {
  field: _react2.default.PropTypes.object.isRequired,
  htmlId: _react2.default.PropTypes.string.isRequired,
  options: _PropTypes.INPUT_OPTIONS_STRUCTURE.isRequired,
  isInlineGroup: _react2.default.PropTypes.bool,
  disabled: _react2.default.PropTypes.bool,
  onChangeHook: _react2.default.PropTypes.func,
  tugoMq: _react2.default.PropTypes.bool,
  applicants: _react2.default.PropTypes.array
};
RadioGroupComponent.defaultProps = {
  isInlineGroup: true
};
exports.default = RadioGroupComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/RadioGroupComponent.jsx
// module id = 81
// module chunks = 0